import { render, staticRenderFns } from "./ItemExportDetails_Details.vue?vue&type=template&id=5754d77b&"
import script from "./ItemExportDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ItemExportDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports